'use es6';

import { getProviderServerError, ERROR_ELEMENT_TYPES } from 'InboxConnectUtils/constants/BasicAuthInboxErrors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BasicAuthConnectErrorTitle({
  errorCode,
  providerType
}) {
  const title = getProviderServerError(providerType, errorCode, ERROR_ELEMENT_TYPES.title);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: title
  });
}